// 正则提取网址的参数 by name
function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2]); return null
}

// 设置 cookie
function setCookie(name, value, day) {
  let oDate = new Date()
  oDate.setDate(oDate.getDate() + day)
  if (day) {
    document.cookie = `${name}=${value};expires=${oDate}`
  } else {
    document.cookie = `${name}=${value}`
  }
}
function setCookie2(name) {
  document.cookie = name
}

// 获取 cookie
function getCookie(name) {
  let arr = document.cookie.split('; ')
  for (let i = 0; i < arr.length; i++) {
    let arr2 = arr[i].split('=')
    if (arr2[0] === name) {
      return arr2[1]
    }
  }

  return ''
}

function removeCookie(name) {
  setCookie(name, 1, -1)
}

// 数组去重
function removeRep(arr) {
  let temArr = []
  arr.forEach(item => {
    if (temArr.indexOf(item) === -1) {
      temArr.push(item)
    }
  })
  return temArr
}

// 数字转位识符判断平台同步状态
function returnBinaryArr(num, type = 1) {
  if ((num & 4) === 4) {
    return type === 1 ? '待删除' : '删除失败'
  } else if ((num & 2) === 2) {
    return type === 1 ? '待创建' : '创建失败'
  } else if ((num & 1) === 1) {
    return type === 1 ? '待修改' : '修改失败'
  } else {
    return type === 1 ? '正常' : '成功'
  }
  // 4  待删除
  // 2  待创建
  // 1  待修改
}

// 处理营业时间
export const dealOpenTime = (str) => {
  str = str.toString()
  if (str.length < 3) str = '0' + str
  if (str.length < 4) str = '0' + str

  return str.slice(0, 2) + ':' + str.slice(2, 4)
}

export const businessHours = (start = 1, range = 48) => {
  let timeList = [
    // {value: 30, label: '00:30'},
  ]
  // 生成 timeList
  for (let i = start; i < range; i++) {
    timeList.push({
      value: 0 + (Math.ceil(i / 2) * 30 + Math.floor(i / 2) * 70),
      label: dealOpenTime(0 + (Math.ceil(i / 2) * 30 + Math.floor(i / 2) * 70))
    })
  }
  timeList.push({
    value: 2359,
    label: '23:59'
  })
  timeList.unshift({
    value: 1,
    label: '00:01'
  })
  timeList.unshift({
    value: 0,
    label: '无'
  })
  return timeList
}

// "HH:mm" 与 中国标准时间之间的转换
export const timeFormat = (time, type) => {
  
  
  if (type === 'time2CST') {
    // time2CST
    let newTime = '' + time
    if(newTime.length === 1) newTime = '00:0' + newTime
    if(newTime.length === 2) newTime = '00:' + newTime
    if(newTime.length === 3) newTime = '0' + newTime.substring(0,1) + ':' + newTime.substring(1)
    if(newTime.length === 4) newTime = newTime.substring(0,2) + ':' + newTime.substring(2)
    
    let y = new Date().getFullYear()
    let m = new Date().getMonth() + 1
    let d = new Date().getDate()
    
    return new Date(y + '/' + m + '/' + d + ' ' + newTime)
  } else {
    // CST2Time
    let hh1 = ('' + new Date(time).getHours()).length === 2 ? new Date(time).getHours() : '0' + new Date(time).getHours()
    let mm1 = ('' + new Date(time).getMinutes()).length === 2 ? new Date(time).getMinutes() :'0' + new Date(time).getMinutes()
    let time1 = hh1 + ":" + mm1
    let newTime = Number((time1.split(':')).join(''))
    return newTime
  }
}

/**
 * 生成时间
 * @param {Array} start 开始时间(包含) ['00', '30']
 * @param {Array} end 结束时间(包含) ['23', '30']
 * @param {Array} step 步长 ['00', '30']
 * s
 */
export function createTime(start = ['00', '30'], end = ['23', '30'], step = ['00', '30'], endTime = '23:59') {
  let arr = []
  let output = [...start]
  arr.push({
    value: +output.join(''),
    label: output.join(':')
  })
  while (+output.join('') < +end.join('')) {
    let hh = +output[0] + +step[0]
    let mm = +output[1] + +step[1]
    if (mm === 60) {
      hh += 1
      mm = 0
    }
    output = [hh < 10 ? '0' + hh : '' + hh, mm < 10 ? '0' + mm : '' + mm]
    arr.push({
      value: +output.join(''),
      label: output.join(':')
    })
  }
  arr.unshift({
    value: 0,
    label: '无'
  })
  if (endTime) {
    arr.push({
      value: 2359,
      label: endTime
    })
  }
  return arr
}

// 计算修改时sku价格
export const computedPrice = (price, sku) => {
  let skuNamePrice = price * 100 // 一斤的价格
  if (skuNamePrice === 1) return skuNamePrice
  let specQuality = sku.specQuality // 质量
  let specUnit = sku.specUnit.toLowerCase() // 单位
  if (specUnit === 'kg' || specUnit === 'l') {
    specQuality = specQuality * 1000
  }
  let temPrice = Math.round(skuNamePrice * specQuality / 500)
  return temPrice
}

// 下载文件
export function downloadFile(url) {
  // 创建a标签模拟点击下载
  let a = document.createElement('a')
  a.hidden = true
  a.href = url
  // a.download = `微盟订单${this.fromDate}_${this.toDate}`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export { getQueryString, setCookie, getCookie, removeCookie, removeRep, returnBinaryArr, setCookie2 }

// import {} from '@/tools/index.js'



// WEBPACK FOOTER //
// ./src/tools/index.js